import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../../hooks/modal/useModal';
import { useChangePasswordForm } from '../../../../hooks/settings/account/useChangePasswordForm';
import { useMainSelector } from '../../../../hooks/useMainSelector';

export const ChangePasswordModal: React.FC = () => {
  const {
    user: { currentUser },
  } = useMainSelector();
  const { control, handleSubmit, errors } = useChangePasswordForm();

  const { hideModal } = useModal();
  const { t } = useTranslation();

  return (
    <form className='tailwind-modal-form' onSubmit={handleSubmit}>
      <div className='tailwind-modal-body'>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='password'
              field='password'
              placeholder={t(
                'account-settings.password.modals.change.password',
              )}
              label={t('account-settings.password.modals.change.password')}
              id='password'
              control={control}
              error={errors.password?.message ? t(errors.password.message) : ''}
            />
          </div>
          {!!currentUser?.mfaEnabled && (
            <div className='col-span-1'>
              <InputWithLabelT
                type='text'
                field='token'
                placeholder={t('account-settings.password.modals.token')}
                label={t('account-settings.password.modals.token')}
                id='twoFaToken'
                control={control}
                error={errors.token?.message ? t(errors.token.message) : ''}
              />
            </div>
          )}
          <div className='col-span-1'>
            <InputWithLabelT
              type='password'
              field='newPassword'
              placeholder={t('account-settings.password.modals.new-password')}
              label={t('account-settings.password.modals.new-password')}
              id='newPassword'
              control={control}
              error={
                errors.newPassword?.message ? t(errors.newPassword.message) : ''
              }
            />
          </div>
          <div className='col-span-1'>
            <InputWithLabelT
              type='password'
              field='retypePassword'
              placeholder={t(
                'account-settings.password.modals.retype-password',
              )}
              label={t('account-settings.password.modals.retype-password')}
              id='retypeNewPassword'
              control={control}
              error={
                errors.retypePassword?.message
                  ? t(errors.retypePassword.message)
                  : ''
              }
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={() => hideModal()}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};

export default ChangePasswordModal;
